import { useEffect, useRef } from "react"

import { createPortal } from "react-dom"

const FullscreenOverlay = ({
  children,
  onClose,
  lockScroll = true,
  closeOnBackdropClick = false,
  closeOnEsc = false,
  zIndex = 9999,
  backdropClassName = "bg-white",
  showClose = true,
  closeAriaLabel = "Tutup overlay",
}) => {
  const containerRef = useRef(null)

  useEffect(() => {
    const prevOverflow = document.body.style.overflow
    if (lockScroll) document.body.style.overflow = "hidden"
    return () => { document.body.style.overflow = prevOverflow }
  }, [lockScroll])

  useEffect(() => {
    if (!closeOnEsc) return
    const handler = (e) => { if (e.key === "Escape") onClose?.() }
    document.addEventListener("keydown", handler)
    return () => document.removeEventListener("keydown", handler)
  }, [closeOnEsc, onClose])

  useEffect(() => { containerRef.current?.focus() }, [])

  const portalNode = (
    <div
      role="dialog"
      aria-modal="true"
      className={`fixed inset-0 ${backdropClassName}`}
      style={{ zIndex }}
      tabIndex={-1}
      ref={containerRef}
      onClick={(e) => {
        if (!closeOnBackdropClick) return
        if (e.target === e.currentTarget) onClose?.()
      }}
    >
      <div className="relative w-full h-full flex flex-col">
        {showClose && (
          <button
            type="button"
            aria-label={closeAriaLabel}
            onClick={onClose}
            className="fixed top-4 right-4 z-50 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            {/* X icon */}
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        )}
        {children}
      </div>
    </div>
  )

  return createPortal(portalNode, document.body)
}

export default FullscreenOverlay
